import script from "./TeacherEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherEditModal.vue?vue&type=script&setup=true&lang=js"

import "./TeacherEditModal.vue?vue&type=style&index=0&id=2d69dc9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d69dc9a"]])

export default __exports__